module.exports = __webpack_public_path__ + "media/src/images/ad1-dfa9f42c77b1e12dacc1df65648321fa.jpg";